import { MarkerType } from 'reactflow'
import type { CustomEdgeType } from './customEdge'

export function generateCustomEdge(id: string, name: string, source: string, target: string, sourceHandle?: string | null, targetHandle?: string | null): CustomEdgeType {
  return {
    id,
    source,
    target,
    sourceHandle: sourceHandle || undefined,
    targetHandle: targetHandle || undefined,
    // animated: true,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 20,
      height: 20,
      // color: 'red',
    },
    type: 'customEdge',
    label: name || '',
    data: {
      edgeName: name || '',
      edgeType: 'Condition',
      hasErr: false,
      errInfo: [],
    },
  }
}
